import { AxiosResponse } from 'axios';

import { UpdateStripePaymentParams, UpdateStripePaymentResponse } from './useUpdateStripePayment.interface';

import collectiveApi from 'modules/common/collectiveApi';

export default async function updateStripePayment(
    params: UpdateStripePaymentParams
): Promise<UpdateStripePaymentResponse> {
    const { data } = await collectiveApi.post<
        UpdateStripePaymentResponse,
        AxiosResponse<UpdateStripePaymentResponse>,
        UpdateStripePaymentParams
    >('stripeupdate/', params);

    return data;
}
